"use strict";
import { tns } from "tiny-slider";

export default function () {
    const valid = document.querySelector(".gallery-container");
    if (valid && window.innerWidth < 1024) {
        const slider = tns({
            container: ".gallery-container",
            items: 1.3,
            slideBy: 1,
            controls: false,
            nav: false,
            gutter: 12,
            loop: true,
            touch: true,
            mouseDrag: true,
            autoplay: true,
        });
    }
}
